<form-field [formGroup]="fieldConfig.formGroup"
            [attr.class]="fieldConfig.className"
            [options]="fieldConfig"
            [isFull]="isFull"
            [labelPosition]="labelPosition">
<div class="number-field-container">
    <div class="field"
         [class.unit-included]="fieldConfig.unit"
         [class.has-icon]="fieldConfig.icon || fieldConfig.iconDefinition" [class.plusAndMinus]="showPlusAndMinus"
         [class.full]="isFull">
        <fa-icon class="icon" *ngIf="fieldConfig.iconDefinition" [icon]="fieldConfig.iconDefinition"></fa-icon>
        <fa-icon class="icon" *ngIf="fieldConfig.icon && (fieldConfig.icon | iconNameToDefinition)"
                 [icon]="fieldConfig.icon | iconNameToDefinition"></fa-icon>
        <number-input *ngIf="!disabled; else disabledField" #inputField
                      [isFull]="isFull"
                      [isAlignBottom]="isAlignBottom"
                      [align]="align"
                      [formControlName]="fieldConfig.formControlName"
                      [min]="fieldConfig.min"
                      [max]="fieldConfig.max"
                      [step]="fieldConfig.step || 1"
                      [fixedDigits]="fieldConfig.fixed"
                      [allowKeyboardArrowsToChangeValues]="false"
                      [tabindex]="fieldConfig.tabindex"
                      [placeholder]="fieldConfig.placeholder"
                      (onSelect)="onFocus.emit($event)"
                      (onKeyUp)="disabled ? false : onKeyup($event)"
                      (onBlur)="onBlur.emit($event)"
                      (onClick)="onClick.emit()"
                      (onChange)="onChange.emit($event)">
        </number-input>
        <ng-template #disabledField>
            {{ fieldConfig.formGroup.get(fieldConfig.formControlName).value }}
        </ng-template>
        <div class="spinner-button increase"
             (click)="!allowIncrease() || disabled ? false : increaseOnClick()"
             [class.unit-included]="fieldConfig.unit"
             [class.unactive]="!allowIncrease() || disabled"
             *ngIf="showPlusAndMinus">
            <fa-icon [icon]="iconPlus"></fa-icon>
        </div>
        <div class="spinner-button decrease"
             (click)="!allowDecrease() || disabled ? false : decreaseOnClick()"
             [class.unactive]="!allowDecrease() || disabled"
             *ngIf="showPlusAndMinus">
            <fa-icon [icon]="iconMinus"></fa-icon>
        </div>
    </div>
    <span *ngIf="fieldConfig.unit" class="number-unit">{{ fieldConfig.unit || "" }}</span>
</div>
</form-field>
